export default "__VITE_ASSET__6SxT$ByN__"